import Echo from 'laravel-echo';

// try {
//     window.$ = window.jQuery = require('../libs/jquery.min.js');

// } catch (e) { }




require('../bootstrap/js/bootstrap.min.js');
require('../libs/jquery.validate.min.js');
require('../libs/jquery.form.min.js');
require('../libs/TweenMax.min.js');
require('../libs/select2.min.js');
require('../libs/main.js');
require('../libs/jquery.isotope.min.js');
require('../libs/owl.carousel.min.js');
require('../libs/jquery-ui.min.js');
require('../libs/jquery.fancybox.pack.js');
require('../libs/jquery.fancybox-media.js');
require('../libs/retina.min.js');
window.Push = require('push.js')

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});



window.Echo.channel('notification')
    .listen('.test.notification', (e) => {
        
        window.Push.create('working');
        console.log('listening event', e);
    });
    
    